import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export const AOSContainer = (props) => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return <div data-aos={props.animationType}>{props.children}</div>;
};

export const AOSWrapper = (props) => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return <div {...props} data-aos={props.animationType}>{props.children}</div>;
};
